import type { RegisteredRouter, RouteIds } from "@tanstack/react-router"
import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import { useCallback } from "react"

import { PurchaseOrdersFilter } from "./PurchaseOrderFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"

interface PurchaseOrderSearchFilterProps {
  routePath: RouteIds<RegisteredRouter["routeTree"]>
  showFilterDrawer: boolean
  toggleDrawer: () => void
}

export const PurchaseOrderFilterDrawer: FC<PurchaseOrderSearchFilterProps> = ({
  routePath,
  showFilterDrawer,
  toggleDrawer,
}) => {
  const navigate = useNavigate({ from: routePath as any })

  const handleClearFilters = useCallback(() => {
    navigate({
      to: ".",
      search: (prev: Record<string, any>) => ({
        ...prev,
        statuses: undefined,
        shipStatuses: undefined,
        outstandingTestResults: undefined,
        start: undefined,
        end: undefined,
      }),
      replace: true,
    })
  }, [navigate])

  return (
    <SearchFilterDrawer toggleDrawer={toggleDrawer} open={showFilterDrawer} clear={handleClearFilters} width={380}>
      <PurchaseOrdersFilter routePath={routePath} />
    </SearchFilterDrawer>
  )
}
